// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { EmojiHappy } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = { EmojiHappy };

// ==============================|| MENU ITEMS - category ||============================== //

const SuperAdminAppVersion: NavItemType = {
    id: 'SuperAdminAppVesrion',
    type: 'group',
    name: 'App Version',
    icon: icons.EmojiHappy,
    children: [
        {
            icon: icons.EmojiHappy,
            id: 'SuperAdminAppVersion',
            title: <FormattedMessage id="App Version" />,
            type: 'item',
            url: '/superadmin/appVersion/update'
        }
    ]
};

export default SuperAdminAppVersion;
